import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { msalInstance, msalReady } from './msalClient';
import ErrorBoundary from './components/error-boundary/error-boundary';
import './index.css'

import { MsalProvider } from '@azure/msal-react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <MsalProvider instance={msalInstance}>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </MsalProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
};

const renderInitFailure = (error: unknown) => {
  const ThrowOnRender = () => {
    throw error instanceof Error ? error : new Error(String(error));
  };
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <ThrowOnRender />
      </ErrorBoundary>
    </React.StrictMode>
  );
};

msalReady.then(renderApp).catch(renderInitFailure);